import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Invoices.frontend.types'

@Injectable({ providedIn: 'root' })
export class Invoices_invoicing_create_invoicesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { instructionId: string, termId: number, entities: { entityType?: string, entityReference?: string, entityId?: number, projectId?: number }[], useExistingInvoice?: boolean }): Promise<{ invoices?: { invoiceId?: number, entityId?: number, entityType?: string, projectId?: number }[], messages?: any[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.instructionId)) {
      $missingRequiredInParams.push('\'instructionId\'');
    }
    if (isNil($inParams.termId)) {
      $missingRequiredInParams.push('\'termId\'');
    }
    if (isNil($inParams.entities)) {
      $missingRequiredInParams.push('\'entities\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

